import cn from 'classnames';
import React from 'react';
import './page__breadcrumbs.scss';

function PageBreadcrumbs({
    action,
    breadcrumbs,
}: {
    action: string;
    breadcrumbs: Array<{ action: string }>;
}): React.ReactElement {
    return (
        <ul className="breadcrumb-tab">
            {breadcrumbs.map(breadcrumb => {
                return (
                    <li key={breadcrumb.action}>
                        <span className={cn({ active: breadcrumb.action === action })}>{breadcrumb.action}</span>
                    </li>
                );
            })}
        </ul>
    );
}

export default PageBreadcrumbs;
